import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import * as echarts from 'echarts/types/dist/echarts';
import * as Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import { LndDashboardDetailComponent } from '../lnd-dashboard-detail/lnd-dashboard-detail.component';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { PmsYearService } from 'src/app/services/pms-year.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

// Exporting(Highcharts); // Initialize exporting module

interface Month {
  key: number;
  name: string;
}
@Component({
  selector: 'app-lnd-dashboard',
  templateUrl: './lnd-dashboard.component.html',
  styleUrls: ['./lnd-dashboard.component.scss'],
})
export class LndDashboardComponent implements OnInit {

  months = [
    { name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'March', value: '03' },
    { name: 'April', value: '04' },
    { name: 'May', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'December', value: '12' }
  ];

  years = Array.from({ length: 10 }, (_, i) => {
    const startYear = new Date().getFullYear() - i;
    const endYear = startYear + 1;
    return { year: `${startYear} - ${endYear}` };
  });
  isUserEmployee: boolean = false;
  selectedYear: any;
  fromDate: any;
  getMonthsList: any = []
  graphType: string = 'bar';  // Default chart type
  fiscalYears: string[] = ['2023-24', '2024-25'];
  //selectedYear: string = '2024-25';
  programs: string[] = ['Programme A', 'Programme B'];
  selectedProgramme: string = 'Programme A';

  chartOptions: any;
  taskColumnHeaderInfoForFinanse: any = []
  allTeamMemberReimbursementApprove: any = []
  selectedYearForCompetency: any = null;
  buttonColorName: any;
  pmsYears: any = [];
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  toYear: any;
  arrAllMonths: any = [];
  selectedMonth: any;
  previousMonthsCountJanDec: any;
  selectedMonthName: any;
  previousMonthsCountAprilMarch: any;
  constructor(public dialog: MatDialog, private cdRef: ChangeDetectorRef, private encryptionService: EncryptionService, private PmsYearService: PmsYearService,
    private httpService: HttpService, private config: Config, public sharedService: SharedService, private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService,) { }


  ngOnInit() {

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    console.log('loggedInUserCompanyID Value:', this.loggedInUserCompanyID); // Debugging

    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getpmsyearlist();
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      this.getMonths(this.fromYear, this.toYear);
    });
  }

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }


  getMonths(fromYear: any, toYear: any) {
    this.arrAllMonths = (this.loggedInCompanyFiscalyear === 'Jan_Dec') ? this.fiscalYearMonthsJanDec : this.fiscalYearMonthsAprilMarch;
    this.selectedMonth = new Date().getMonth() + 1;

    const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === this.selectedMonth
    );
    this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;

    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

    // Find index of selected month for fiscalYearMonthsJanDec
    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountJanDec = this.selectedMonth; // Count from January


  }


  onMonthChange(event: any) {
    const selectedMonthKey = event.value;
    this.selectedMonth = selectedMonthKey;
    // console.log('Selected month key:', this.selectedMonth);

    const selectedMonthObj: Month | undefined = this.fiscalYearMonthsJanDec.find(
      (m: Month) => m.key === this.selectedMonth
    );
    this.selectedMonthName = selectedMonthObj ? selectedMonthObj.name : null;


    // Recalculate previousMonthsCountAprilMarch
    const indexAprilMarch = this.fiscalYearMonthsAprilMarch.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountAprilMarch = indexAprilMarch + 1; // Count from April

    // Recalculate previousMonthsCountJanDec
    const indexJanDec = this.fiscalYearMonthsJanDec.findIndex(m => m.key === this.selectedMonth);
    this.previousMonthsCountJanDec = this.selectedMonth; // Count from January



  }

  fiscalYearMonthsAprilMarch = [
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
  ];

  fiscalYearMonthsJanDec = [
    { key: 1, name: "January" },
    { key: 2, name: "February" },
    { key: 3, name: "March" },
    { key: 4, name: "April" },
    { key: 5, name: "May" },
    { key: 6, name: "June" },
    { key: 7, name: "July" },
    { key: 8, name: "August" },
    { key: 9, name: "September" },
    { key: 10, name: "October" },
    { key: 11, name: "November" },
    { key: 12, name: "December" },
  ];


  getYearSetupForReimbursement(year: any) {
    this.selectedYearForCompetency = year;

    this.selectedYear = year;
    // console.log(this.selectedYear)

  }

  switchGraphType(type: string) {
    this.graphType = type;
    // this.loadGraph();
  }

  onClickCard(event: any) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '100%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      btn2: 'OK',
      moduleName: event,
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(LndDashboardDetailComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((_result) => {
    });

  }

  arrEmployeeWiseTrendsbyYear: any
  selectedGraphEmployee: any;
  arrEmployeesReport: any
  downloadGraph() { }


  selectedGraphEmployeeChange(event: any) { }

  isApprovedByFinanceIcon: any = 'bar';
  selectGraphTwoType: any = 'bar';
  isApprovedByFinanceTable: any = false;
  arrApprovedByFinanceTable: any = [];


  switchApprovedByFinanceGraph(graphType: any) {
    this.selectGraphTwoType = graphType;
    this.isApprovedByFinanceIcon = graphType;
    this.isApprovedByFinanceTable = false;
    if (graphType == 'bar') {
      // this.getDashboardGraphData('bar');
    }
    if (graphType == 'line') {
      // this.getDashboardGraphData('line');
    }

  }

  barChartActive(data: any, idSelector: any, graphType: any): void {
    // createChart(idSelector, 'bar', graphType, data, {
    //   xAxisName: data.xAxisName,
    //   yAxisName: data.yAxisName,
    // });
  }

  // Usage for Line Chart
  lineChartActive(data: any, idSelector: any, graphType: any): void {
    // createChart(idSelector, 'line', graphType, data, {
    //   xAxisName: data.xAxisName,
    //   yAxisName: data.yAxisName,
    // });
  }

  switchApprovedByFinanceTable() {
    this.selectGraphTwoType = 'table';
    this.isApprovedByFinanceIcon = '';
    this.isApprovedByFinanceTable = true;

  }


  downloadChartAsPDF(type: any): void {
    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;


    var idSelector = (this.selectGraphTwoType == 'table') ? 'table-employee-wise-trends-data' : 'bar-line-chart-nine-box';

    // let selectedGraphEmployee = this.arrEmployeesReport.filter((item: any) => item.userId == this.selectedGraphEmployee);

    //Call the common function from the service
    // this.PdfDownload.downloadPDF(
    //   idSelector, // chartId
    //   type, // Title
    //   selectedGraphEmployee[0]?.name,?
    //   "", // From Date
    //   "",
    // );
  }


  // =================== Dropdown for Department ================

  selectedDepartment: any = [];
  getDepartmentsList: any[] = [];

  dropdownSettings = {
    singleSelection: false,  // or true based on your requirement
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  onDepartmentSelect() {

  }

  onDepartmentDeSelect() {

  }

  onDepartmentAllSelect() {

  }

  onDepartmentAllDeSelect() {

  }


  // =================== Dropdown for Employee ================

  getEmployeeList: any[] = [];


  onEmployeeSelect() {

  }

  onEmployeeDeSelect() {

  }

  onEmployeeAllSelect() {

  }

  onEmployeeAllDeSelect() {

  }


}

